import { render, staticRenderFns } from "./StationPhoto.vue?vue&type=template&id=2527ec6e&scoped=true"
import script from "./StationPhoto.vue?vue&type=script&lang=ts"
export * from "./StationPhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527ec6e",
  null
  
)

export default component.exports